import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'Literalmente me salvó las cenas. Todo rápido, rico y súper fácil de hacer.',
  author: 'Camila R.',
  gender: 'female'
}, {
  text: 'Pensé que iba a ser el típico ebook aburrido pero estuvo genial.',
  author: 'Martín G.',
  gender: 'male'
}, {
  text: 'Me re sirvió para dejar de pedir comida todos los días.',
  author: 'Sofía M.',
  gender: 'female'
}, {
  text: 'La mejor compra low ticket que hice este año.',
  author: 'Luciano T.',
  gender: 'male'
}, {
  text: 'Las cenas parecen cheat meals pero son fitness.',
  author: 'Valentina P.',
  gender: 'female'
}, {
  text: 'Lo compré sin esperar mucho y terminé usando recetas todos los días.',
  author: 'Nicolás A.',
  gender: 'male'
}, {
  text: 'Está buenísimo porque no necesitas ingredientes raros.',
  author: 'Agustina F.',
  gender: 'female'
}, {
  text: 'Me ayudó muchísimo con el meal prep.',
  author: 'Federico L.',
  gender: 'male'
}, {
  text: 'Las recetas de air fryer fueron una locura.',
  author: 'Julieta C.',
  gender: 'female'
}, {
  text: 'Ideal si querés comer mejor sin complicarte.',
  author: 'Bruno S.',
  gender: 'male'
}];
export function Testimonials() {
  return <section className="py-24 md:py-28 bg-white overflow-hidden" data-id="element-193">
      <div className="container mx-auto px-4" data-id="element-194">
        <div className="text-center mb-16 md:mb-20" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-black text-darkGreen mb-6 font-montserrat uppercase" data-id="element-196">
            Lo que dicen{' '}
            <span className="text-vibrantGreen" data-id="element-197">nuestros clientes</span>
          </h2>
          <div className="flex items-center justify-center gap-1 mb-4" data-id="element-198">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-199" />)}
          </div>
          <p className="text-gray-600 font-medium text-lg" data-id="element-200">
            Más de{' '}
            <strong className="text-darkGreen font-bold" data-id="element-201">5,000 personas</strong>{' '}
            ya transformaron sus cenas
          </p>
        </div>

        {/* Masonry-like grid for testimonials */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 max-w-7xl mx-auto space-y-6" data-id="element-202">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index % 3 * 0.1
        }} className="break-inside-avoid bg-gray-50 p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-203">
              <div className="flex items-center gap-1 mb-4" data-id="element-204">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-205" />)}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-206">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-207">
                <img src={`https://i.pravatar.cc/150?u=${testimonial.author.replace(' ', '')}`} alt={testimonial.author} className="w-10 h-10 rounded-full bg-gray-200 object-cover" data-id="element-208" />
                <div data-id="element-209">
                  <p className="font-bold text-darkGreen text-sm" data-id="element-210">
                    {testimonial.author}
                  </p>
                  <p className="text-xs text-vibrantGreen font-medium flex items-center gap-1" data-id="element-211">
                    <span className="w-2 h-2 rounded-full bg-vibrantGreen inline-block" data-id="element-212"></span>
                    Compra Verificada
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}